import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { getEnvironmentBaseUrl } from 'utilities/route-utils';

interface ExternalRedirectProps {
    to: string;
}

const ExternalRedirect: React.FC<ExternalRedirectProps> = ({ to }) => {
    React.useEffect(() => {
        const baseUrl = getEnvironmentBaseUrl();
        const redirectUrl = `${baseUrl}/scp/cshub/billing/billing${to}`;
        window.location.assign(redirectUrl);
    }, [to]);
    return null;
};



export const CustomerBillingRouting = () => {
    return (
        <Switch>
            <Route
                path="/customer-billing/issue-invoices"
                render={() => (
                    <ExternalRedirect to="/issue-invoices" />
                )}
            />
            <Route
                path="/customer-billing/raise-credit-notes"
                render={() => (
                    <ExternalRedirect to="/view-invoice" />
                )}
            />
        </Switch>
    );
};